import type { InferResponse } from '@/hooks/useApiClient'

export type AlertResponse = InferResponse<'/alert/get'>

export type AlertType = AlertResponse['unresolved'][number] | AlertResponse['resolved'][number]

export const alertTypes = {
  SUPPLY_NEEDS_ATTENTION: 'supply_needs_attention',
  POTENTIAL_MISDROP: 'potential_misdrop',
  CARRIER_ORDER_REJECT: 'carrier_reject_order',
  TRAILER_SWAP: 'trailer_swap',
  VOLUME_DISCREPANCY: 'volume_discrepancy',
  PRODUCT_MISMATCH: 'product_mismatch',
  SUPPLIER_MISMATCH: 'supplier_mismatch',
  WRONG_LOCATION: 'wrong_location',
} as const
